import React from "react";
import { useState, useEffect } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useParams, Link } from "react-router-dom";
import Select from "react-select";
import moment from "moment";
import TimePicker from "react-bootstrap-time-picker";
import validate from "./validate";
import { API_URL } from "../../../../constants";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import { GetServiceCaller, PostServiceCaller, } from "../../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { Form } from "react-bootstrap";

const customStyle = {
    control: (provided, state) => ({
        ...provided,
        height: "80px",
        overflow: "scroll",
    }),
    multiValueRemove: (base, state) => ({
        ...base,
        color: "white", // Sets the color of the cancel icon
        ":hover": {
            backgroundColor: "red", // Adjust hover background color if needed
            color: "white", // Adjust hover color here
        },
    }),
};

function ScheduleInterviewEditPage() {
    const navigate = useNavigate();

    const dispatch = useDispatch();
    useEffect(() => {
        fetchShowApi();
        dispatch(updateNavbarHeading("Edit Schedule Interview"));
    }, []);

    const initialFormData = {
        JobDescriptionID: "",
        JobMasterID: "",
        JobTitle: "",
        CandidateID: "",
        Interviewee: "",
        InterviewerID: "",
        SecondaryInterviewerIDs: "",
        InterviewMode: "",
        InterviewDate: 36000,
        InterviewTime: "",
        InterviewToTime: "",
        Round: "",
        FeedbackCategory: "",
        IsFinalRound: false,
        ResumePath: "",
        Remark: "",
    };
    const [pageLoading, setPageLoading] = useState(true);
    const [submitted, setSubmit] = useState(false);
    const [jobTitleOpts, setJObTitleOpts] = useState([]);
    let [errors, setErrors] = useState({});
    const [interviewerOpts, setinterviewerOpts] = useState([]);
    const [roundsOpts, setRoundsOpts] = useState([]);
    const [feedbackOpts, setFeedbackOpts] = useState([]);
    const [mailOpts, setMailOpts] = useState([]);
    const { edit_id } = useParams();
    const [formData, setFormData] = useState(initialFormData);
    console.log("formData", formData);

    const [interviewModeOpt, setMode] = useState([
        { value: "", label: "Select..." },
        { value: "In Person", label: "In Person" },
        { value: "Virtual", label: "Virtual" },
    ]);


    const fetchShowApi = async () => {
        try {
            let response;

            response = await GetServiceCaller(`${API_URL}scheduleinterviews/${edit_id}`)
            console.log("response:::::::", response);

            if (response?.status == 200) {
                setPageLoading(false)
                const cleanedData = response?.data?.data
                const jobtitleopts = cleanedData?.jobtitle?.map(
                    (tech) => ({
                        value: tech.value,
                        label: tech.text,
                    })
                );
                //setting dropdown data
                setJObTitleOpts(jobtitleopts);
                setinterviewerOpts(cleanedData?.interviewers);
                setRoundsOpts(cleanedData?.rounds);
                setFeedbackOpts(cleanedData?.feedback_categories_list);
                setMailOpts(cleanedData?.email_template_list);
                let interviewDetailsRes = cleanedData?.headers;

                //setting selected option for dropdown
                let selectedJobDescriptionId = jobtitleopts.find(
                    (o) => o.value == interviewDetailsRes.JobMasterID
                );
                let selectedInterviewerId =
                    cleanedData?.interviewers.find(
                        (o) => o.value == interviewDetailsRes.InterviewerID
                    );
                let selectedRound = cleanedData?.rounds.find(
                    (o) => o.value == interviewDetailsRes.Round
                );
                let selectedCategory =
                    cleanedData?.feedback_categories_list.find(
                        (o) => o.value == interviewDetailsRes.FeedbackMasterID
                    );

                selectedInterviewerId.label = selectedInterviewerId.text;
                selectedRound.label = selectedRound.text;
                selectedCategory.label = selectedCategory.text;
                let selectedInterviewMode = interviewModeOpt.find(
                    (o) => o.value == interviewDetailsRes.Location
                );


                const selectedSecondaryInterviewers = cleanedData?.interviewers?.filter(el =>
                    interviewDetailsRes?.SecondaryInterviewerIDs?.split(",").includes(el.value)
                );
                let interviewFormData = {
                    id: edit_id,
                    JobMasterID: selectedJobDescriptionId,
                    CandidateID: interviewDetailsRes.CandidateID,
                    Interviewee: interviewDetailsRes.interviewee,
                    InterviewerID: selectedInterviewerId,
                    SecondaryInterviewerIDs: interviewDetailsRes?.SecondaryInterviewerIDs,
                    InterviewMode: selectedInterviewMode,
                    InterviewDate: moment(interviewDetailsRes.InterviewDate).format(
                        "DD-MMM-YYYY"
                    ),
                    InterviewTime: interviewDetailsRes.OldInterviewTime,
                    Round: selectedRound,
                    InterviewToTime: interviewDetailsRes?.InterviewEndTime,
                    FeedbackCategory: selectedCategory,
                    IsFinalRound: interviewDetailsRes.IsFinalRound ? true : false,
                    ResumePath: interviewDetailsRes.ResumePath,
                    ResumeBasePath: interviewDetailsRes.ResumeBasePath,
                    Remark: interviewDetailsRes.Remark,
                };
                setFormData(interviewFormData);
            }

        } catch (error) {
            console.error("Fetching Show Api Error ", error);

        }
    }

    const intervieweropts = interviewerOpts?.map((tech) => ({
        value: tech.value,
        label: tech.text,
    }));

    const roundopts = roundsOpts?.map((tech) => ({
        value: tech.value,
        label: tech.text,
    }));
    roundopts?.unshift({
        value: null,
        label: "Select....",
    });
    const feedbackopts = feedbackOpts?.map((tech) => ({
        value: tech.value,
        label: tech.text,
    }));
    const mailopts = mailOpts?.map((record) => ({
        value: record.value,
        label: record.text,
    }));
    const handleDateChange = (date, name) => {
        setFormData({ ...formData, [name]: moment(date).format("DD-MMM-YYYY") });

        setErrors((prevErrors) => ({
            ...prevErrors,
            InterviewDate: "",
        }));
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const handleDropdownChange = (selected, name) => {
        setFormData({ ...formData, [name]: selected });
        if (selected?.value != "") {
            setErrors((errors) => ({
                ...errors,
                [name]: {},
            }));
        }
    };
    // Convert "HH:mm:ss" to seconds (for comparison)
    const timeStringToSeconds = (timeStr) => {
        if (!timeStr || typeof timeStr !== "string") return 0; // safe default
        const [h, m, s] = timeStr.split(':').map(Number);
        return h * 3600 + m * 60 + (s || 0);
    };


    // Convert seconds back to "HH:mm:ss" (for display)
    const secondsToTimeString = (totalSeconds) => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const pad = (num) => num.toString().padStart(2, '0');
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    };

    const handleTimeChange = (value, fieldName) => {
        const newTimeStr = secondsToTimeString(value);
        const newTimeInSeconds = timeStringToSeconds(newTimeStr);

        const fromTimeSec = timeStringToSeconds(formData.InterviewTime);
        const toTimeSec = timeStringToSeconds(formData.InterviewToTime);

        let newFromTime = formData.InterviewTime;
        let newToTime = formData.InterviewToTime;

        if (fieldName === "InterviewTime") {
            newFromTime = newTimeStr;
            if (newTimeInSeconds >= toTimeSec) {
                newToTime = secondsToTimeString(newTimeInSeconds + 1800); // +30 mins
                // toast.info("End time adjusted to maintain a 30-minute gap.");
            } else if (toTimeSec - newTimeInSeconds < 1800) {
                // toast.error("End time must be at least 30 minutes after start time.");
                return; // Prevent update if validation fails
            }
        } else if (fieldName === "InterviewToTime") {
            newToTime = newTimeStr;
            if (newTimeInSeconds <= fromTimeSec) {
                toast.error("End time cannot be before start time.");
                newToTime = secondsToTimeString(fromTimeSec + 1800); // Auto-adjust
                // toast.info("End time adjusted to 30 minutes after start time.");
            } else if (newTimeInSeconds - fromTimeSec < 1800) {
                // toast.error("End time must be at least 30 minutes after start time.");
                return; // Prevent update if validation fails
            }
        }

        setFormData(prev => ({
            ...prev,
            InterviewTime: newFromTime,
            InterviewToTime: newToTime,
        }));
    };

    const handleCheckBoxChange = (e) => {
        setFormData({ ...formData, IsFinalRound: !formData.IsFinalRound });
    };
    const handleOnTouch = async (e) => {
        const { name, value } = e.target;
        let error = await validate(name, value, formData);
        setErrors((errors) => ({
            ...errors,
            [name]: error,
        }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        let mandatory_field = [
            "JobMasterID",
            "JobMasterID",
            "Interviewee",
            "InterviewerID",
            // "SecondaryInterviewerIDs",
            "InterviewMode",
            "InterviewDate",
            "InterviewTime",
            "InterviewToTime",
            "Round",
            "FeedbackCategory",
        ];
        let isFormInvalid = false;
        for (let field of mandatory_field) {
            let error = await validate([field], formData[field], formData);
            if (error.status == true) {
                isFormInvalid = true;
            }
            setErrors((errors) => ({
                ...errors,
                [field]: error,
            }));
        }

        if (!isFormInvalid) {
            setSubmit(true);
            try {
                formData.FeedbackCategory = formData.FeedbackCategory;
                formData.InterviewerID = formData.InterviewerID;
                formData.SecondaryInterviewerIDs = formData.SecondaryInterviewerIDs || [];
                formData.JobDescriptionID = formData.JobDescriptionID;
                formData.Round = formData.Round;
                formData.IntervieweeMailTemplateID = mailopts[1].value;
                formData.InterviewerMailTemplateID = mailopts[2].value;
                formData.SchedularMailTemplateID = mailopts[2].value;
                let response;
                response = await PostServiceCaller(`${API_URL}scheduleinterviews/${edit_id}`, formData, 'put');
                if (response.data.status == "success") {
                    toast.success(response.data.message);
                    setSubmit(false);
                    navigate("/schedule-interview-list");
                } else {
                    setSubmit(false);
                    toast.error(response.data.message);
                }
            } catch (error) {
                setSubmit(false);
                console.error("Error submitting form data:", error);
            }
        }
    };

    if (pageLoading) {
        return (
            <>
                <p class="position-absolute top-50 start-50 translate-middle text-center">
                    <FaSpinner class="spinner" />
                </p>
            </>
        );
    } else {
        return (
            <>
                <div className="Container">
                    <form id="formOne" className="rounded mt-2 p-2 bg-white" onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-6 col-lg-3">
                                <label className="form-label">
                                    Job Title<span class="required">*</span>
                                </label>
                                <Select
                                    value={formData.JobMasterID}
                                    onBlur={handleOnTouch}
                                    name="JobMasterID"
                                    onChange={(selected) =>
                                        handleDropdownChange(selected, "JobMasterID")
                                    }
                                    class="form-control"
                                    options={[{ value: "", label: "Select..." }, ...jobTitleOpts]}
                                    required
                                />
                                {errors?.JobMasterID?.status && (
                                    <span class="error">{errors?.JobMasterID?.message}</span>
                                )}
                            </div>
                            <div className="col-md-6 col-lg-3">
                                <label className="form-label">
                                    Interviewee<span class="required">*</span>
                                </label>
                                <Form.Control
                                    onChange={handleChange}
                                    onBlur={handleOnTouch}
                                    type="text"
                                    placeholder=""
                                    name="Interviewee"
                                    value={formData.Interviewee}
                                />
                                {errors?.Interviewee?.status && (
                                    <span class="error">{errors?.Interviewee?.message}</span>
                                )}
                            </div>
                            <div className="col-md-6 col-lg-3">
                                <label className="form-label">
                                    Interviewer<span class="required">*</span>
                                </label>
                                <Select
                                    name="InterviewerID"
                                    value={formData.InterviewerID}
                                    onChange={(selected) =>
                                        handleDropdownChange(selected, "InterviewerID")
                                    }
                                    options={[
                                        { value: "", label: "Select..." },
                                        ...intervieweropts,
                                    ]}
                                />
                                {errors?.InterviewerID?.status && (
                                    <span class="error">{errors?.InterviewerID?.message}</span>
                                )}
                            </div>
                            <div className="col-md-6 col-lg-3">
                                <label className="form-label">
                                    Secondary Interviewer
                                </label>
                                <Select
                                    name="SecondaryInterviewerIDs"
                                    value={
                                        intervieweropts.filter(opt =>
                                            formData.SecondaryInterviewerIDs?.split(",").includes(String(opt.value))
                                        )
                                    }
                                    onChange={(selected) =>
                                        handleDropdownChange(
                                            selected ? selected.map(item => item.value).join(",") : "",
                                            "SecondaryInterviewerIDs"
                                        )
                                    }
                                    styles={customStyle}
                                    menuShouldScrollIntoView={true}
                                    isMulti
                                    options={[
                                        { value: "", label: "Select...", isDisabled: true },
                                        ...intervieweropts,
                                    ]}
                                />

                                {errors?.SecondaryInterviewerIDs?.status && (
                                    <span class="error">{errors?.SecondaryInterviewerIDs?.message}</span>
                                )}
                            </div>

                        </div>
                        {/* SecondRow */}
                        <div className="row mt-3">

                            <div className="col-md-6 col-lg-3">
                                <label className="form-label">Interview Mode<span class="required">*</span></label>
                                <Select
                                    name="InterviewMode"
                                    value={formData.InterviewMode}
                                    onChange={(selected) =>
                                        handleDropdownChange(selected, "InterviewMode")
                                    }
                                    options={[
                                        { value: "", label: "Select..." },
                                        { value: "In Person", label: "In Person" },
                                        { value: "Virtual", label: "Virtual" },
                                    ]}
                                />
                                {errors?.InterviewMode?.status && (
                                    <span class="error">{errors?.InterviewMode?.message}</span>
                                )}
                            </div>
                            <div className="col-md-6 col-lg-3">
                                <label className="form-label">
                                    Interview Date<span class="required">*</span>
                                </label>
                                <ReactDatePicker
                                    onBlur={handleOnTouch}
                                    minDate={new Date()}
                                    autoComplete="off"
                                    showPopperArrow
                                    showIcon
                                    icon="fa fa-calendar"
                                    className="form-control"
                                    placeholderText="Interview Date"
                                    format="DD-MMM-YYYY"
                                    name="InterviewDate"
                                    id="InterviewDate"
                                    onChange={(date) => handleDateChange(date, "InterviewDate")}
                                    value={formData.InterviewDate}
                                />
                                {errors?.InterviewDate?.status && (
                                    <span class="error">{errors?.InterviewDate?.message}</span>
                                )}
                            </div>
                            <div className="col-md-6 col-lg-3">
                                <label className="form-label">
                                    Interview Start Time<span class="required">*</span>
                                </label>
                                <TimePicker
                                    name="InterviewTime"
                                    value={formData.InterviewTime}  // Now in "HH:mm:ss" format
                                    start="08:00"

                                    step={15}
                                    onChange={(e) => handleTimeChange(e, "InterviewTime")}
                                />
                                {errors?.InterviewTime?.status && (
                                    <span class="error">{errors?.InterviewTime?.message}</span>
                                )}
                            </div>

                            <div className="col-md-6 col-lg-3">
                                <label className="form-label">
                                    Interview End Time<span class="required">*</span>
                                </label>
                                <TimePicker
                                    name="InterviewToTime"
                                    start="08:30"

                                    value={formData.InterviewToTime}  // Now in "HH:mm:ss" format
                                    step={15}
                                    onChange={(e) => handleTimeChange(e, "InterviewToTime")}
                                />

                                {errors?.InterviewToTime?.status && (
                                    <span class="error">{errors?.InterviewToTime?.message}</span>
                                )}
                            </div>
                        </div>
                        {/* ThirdRow */}
                        <div className="row mt-3">
                            <div className="col-md-6 col-lg-3">
                                <label className="form-label">
                                    Interviewee Mail Template<span class="required">*</span>
                                </label>
                                <input
                                    className="form-control"
                                    isDisabled={false}
                                    name="intervieweeMailTemplate"
                                    value={mailOpts?.[1]?.text}
                                    disabled
                                />
                            </div>
                            <div className="col-md-6 col-lg-3">
                                <label className="form-label">
                                    Interviewer Mail Template<span class="required">*</span>
                                </label>
                                <input
                                    className="form-control"
                                    name="interviewerMailTemplate"
                                    value={mailOpts?.[2]?.text}
                                    disabled
                                />
                            </div>
                            <div className="col-md-6 col-lg-3">
                                <label className="form-label">
                                    Scheduler Mail Template<span class="required">*</span>
                                </label>
                                <input
                                    className="form-control"
                                    isDisabled={true}
                                    name="ScheduleMailTemplate"
                                    // onChange={formik.handleChange}
                                    disabled
                                    value={mailOpts?.[2]?.text}
                                    required
                                />
                            </div>
                            <div className="col-md-6 col-lg-3">
                                <label className="form-label">
                                    Round<span class="required">*</span>
                                </label>
                                <Select
                                    options={roundopts}
                                    name="Round"
                                    value={formData.Round}
                                    onChange={(selected) =>
                                        handleDropdownChange(selected, "Round")
                                    }
                                />

                                {errors?.Round?.status && (
                                    <span class="error">{errors?.Round?.message}</span>
                                )}
                            </div>



                        </div>
                        {/* FourthRow */}
                        <div className="row mt-3">
                            <div className="col-md-6 col-lg-3">
                                <label className="form-label">
                                    Feedback Template<span class="required">*</span>
                                </label>
                                <Select
                                    options={[{ value: "", label: "Select..." }, ...feedbackopts]}
                                    name="FeedbackCategory"
                                    value={formData.FeedbackCategory}
                                    onChange={(selected) => {
                                        handleDropdownChange(selected, "FeedbackCategory");
                                    }}
                                />
                                {errors?.FeedbackCategory?.status && (
                                    <span class="error">{errors?.FeedbackCategory?.message}</span>
                                )}
                            </div>
                            <div className="col-md-6 col-lg-3">
                                <label className="form-label"> Remark </label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    name="Remark"
                                    value={formData.Remark}
                                    onChange={handleChange}
                                ></Form.Control>
                            </div>

                            <div className="col-md-6 col-lg-3">
                                <div className="form-check">
                                    <label className="form-check-label">Is Final Round </label>
                                    <input
                                        onChange={handleCheckBoxChange}
                                        className="form-check-input"
                                        type="checkbox"
                                        name="IsFinalRound"
                                        checked={formData.IsFinalRound}
                                    />
                                </div>
                            </div>

                            <div className="col-md-6 col-lg-3">
                                <strong>Resume</strong>
                                <br />
                                <p>
                                    <a
                                        href={formData.ResumeBasePath}
                                        target="_blank"
                                    >
                                        {formData.ResumePath ? formData.ResumePath : ""}
                                    </a>
                                </p>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="text-end ">
                                <button
                                    className="cancel-btn me-2"
                                    onClick={() => navigate('/schedule-interview-list')}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    disabled={submitted ? true : false}
                                    className="custom-btn"
                                >
                                    {submitted ? <FaSpinner class="sm-spinner" /> : "Submit"}
                                </button>
                            </div>
                        </div>

                    </form>
                </div>
            </>
        );
    }
}

export default ScheduleInterviewEditPage;
